import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { LoadingService } from '../../@core/services/loading.service';
import { StopService } from '../../@core/services/stop.service';
import { NonCompletedDialogComponent } from '../../@theme/components/non-completed-dialog/non-completed-dialog.component';

@Component({
  selector: 'ngx-auth',
  styleUrls: ['./auth.component.scss'],
  templateUrl: './auth.component.html'
})
export class AuthComponent implements OnInit, OnDestroy {
  color = 'primary';
  mode = 'indeterminate';
  value = 50;
  sub: Subscription;
  displayProgressSpinner = false;

  constructor(
    private _loadingService: LoadingService,
    private stopService: StopService,
    public dialog: MatDialog,
    private _renderer: Renderer2
  ) {}

  ngOnInit() {
    this.sub = this._loadingService.displayProgressSpinner.subscribe((res) => {
      this.displayProgressSpinner = res;
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  switchTheme(toggleValue: any) {
    console.log(toggleValue);
    if (toggleValue === true) {
      this._renderer.addClass(document.body, 'dark-theme');
      this._renderer.removeClass(document.body, 'light-theme');
    } else {
      this._renderer.addClass(document.body, 'light-theme');
      this._renderer.removeClass(document.body, 'dark-theme');
    }
  }

  openNonCompletedDialog(): void {
    const dialogRef = this.dialog.open(NonCompletedDialogComponent, {
      height: '740px',
      width: '1400px',
      data: { search: true }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.stopService.ncDataSource = null;
    });
  }
}
